import { createBrowserRouter, RouterProvider } from "react-router-dom"
import App from "../../App"


const router = createBrowserRouter([
    // match everything with "*"
    { path: "*", element: <App /> }
  ])

export default router